import React, { useState, useEffect, useCallback } from 'react';

import { Grid, Box, Button, Typography, Checkbox, List, ListItem, ListItemText, FormControlLabel } from '@mui/material';
import { makeStyles } from "@material-ui/core/styles";
import { useSelector, useDispatch } from "react-redux";

// import RadioButtonUncheckedIcon from "@mui/icons-material/RadioButtonUnchecked";
// import CircleIcon from "@mui/icons-material/Circle";

import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import Select from '@mui/material/Select';

import TopButton from "../../../Components/UI/TopButtons";
import Placeholder from "../../../Components/UI/Placeholder";

import { getFormatedDate, addDays } from "../../../Js/TimeAndDate";
import { joinByKeys, getClassNames } from "../../../Js/Common";
import { getUsersByRoleId } from "../../Users/Services";
import { sortBy, uniq, concat, map, startCase, find, findIndex } from "lodash";
import GroupStackBarChart from './GroupStackBarChart';
import PolarProgressChart from './PolarProgressChart';
import { getProgressiveSummaryLogs } from '../Services';
import { blue } from '@mui/material/colors';

import { commonSliceActions } from "../../../Store/Slices/CommonSlice";

const filterByDays = [
    { 'value': 30, 'label': '1 Month' },
    { 'value': 90, 'label': '3 Month' },
    { 'value': 180, 'label': '6 Month' },
    { 'value': 270, 'label': '9 Month' },
    { 'value': 365, 'label': '1 Year' }
];

const colorsCode = [
    '#4B0082', '#C71585', '#2F4F4F', '#708090', '#D2691E', '#8B4513', '#A52A2A', '#00008B',
    '#A52A2A', '#800080', '#800000', '#008000', '#808000', '#FFC0CB', '#7FFFD4', '#808080',
    '#FF0000', '#00FFFF', '#FF00FF', '#36454F'
];

const ProgressInTrainerLogin = () => {
    // Hooks
    const classes = useStyles();
    const dispatch = useDispatch();

    // Redux state
    const userInfo = useSelector((state) => state.loggedInUserInfo.userInfo);
    const serverRole = useSelector((state) => state.defs.serverRole);
    const { loader } = useSelector((state) => state.common);

    //State
    const [allClasses, setAllClasses] = useState([]);
    const [selectedClassId, setSelectedClassId] = useState(null);

    const [learnerData, setLearnerData] = useState([]);
    const [selectedLearnerId, setSelectedLearnerId] = useState(null);

    const [uniqSkillArr, setUniqSkillArr] = useState([]);
    const [finalSeriesOneSkills, setFinalSeriesOneSkills] = useState([]);
    const [finalSeriesTwoSkills, setFinalSeriesTwoSkills] = useState([]);
    const [finalSeriesThreeSkills, setFinalSeriesThreeSkills] = useState([]);
    const [selectedDropdownData, setSelectedDropdownData] = useState([filterByDays[0]]);
    const [selectedMonthValue, setSelectedMonthValue] = useState([]);
    const [errorMessage, setErrorMessage] = useState(null);

    const [resSeriesOneSummaryLogs, setResSeriesOneSummaryLogs] = useState([]);
    const [resSeriesTwoSummaryLogs, setResSeriesTwoSummaryLogs] = useState([]);
    const [resSeriesThreeSummaryLogs, setResSeriesThreeSummaryLogs] = useState([]);

    const [startDate1, setStartDate1] = useState(null);
    const [endDate1, setEndDate1] = useState(null);
    const [startDate2, setStartDate2] = useState(null);
    const [endDate2, setEndDate2] = useState(null);
    const [startDate3, setStartDate3] = useState(null);
    const [endDate3, setEndDate3] = useState(null);
    const [checkedSkills, setCheckedSkills] = useState([]);
    const [allChecked, setAllChecked] = useState(true);
    const [showLegends, setShowLegends] = useState(false);

    useEffect(() => {
        initialRender();
    }, []);

    const initialRender = useCallback(async () => {
        let allClassesData = await getClassNames(userInfo.site_uuid);
        setAllClasses(allClassesData);
    }, [])

    const handleClassChange = (itemData) => {
        resetState();
        setSelectedClassId(itemData.id);
        fetchUsersByRole(itemData.id);
    };

    const fetchUsersByRole = async (selectedClassId) => {
        let params = {
            query: {
                $select: ['uid', 'name'],
                site_uuid: userInfo.site_uuid,
                belongs_to: selectedClassId,
                status: true,
                $limit: -1,
            },
        };

        let resUsersData = await getUsersByRoleId(params);
        console.log("res==>", resUsersData);
        setLearnerData(sortBy(resUsersData.data, [
            (o) => {
                return o.name.firstname;
            },
        ]));
    };

    const handleClassChange1 = (itemData) => {
        console.log("itemData1", itemData);
        // dispatch(commonSliceActions.resetState());
        // dispatch(commonSliceActions.setLoader(true));

        setSelectedLearnerId(itemData.uid);
        setSelectedMonthValue([]);
        resetSkillsData();
    };

    const fetchProgressiveSummaryLog = async () => {
        setErrorMessage(null);
        if(selectedMonthValue.length<=0) {
            setErrorMessage('No Data Found!');
            return ;
        }

        dispatch(commonSliceActions.setLoader(true));
        let params = {
            query: {
                actor: selectedLearnerId,
                site_uuid: userInfo.site_uuid,
                startDate: startDate1,
                endDate: endDate1
            },
        };
        let resSeriesOneSummaryLogs = await getProgressiveSummaryLogs(params);
        setResSeriesOneSummaryLogs(resSeriesOneSummaryLogs.data);        
        console.log("resSeriesOneSummaryLogs===>", resSeriesOneSummaryLogs);

        let paramsSeriesTwo = {
            query: {
                actor: selectedLearnerId,
                site_uuid: userInfo.site_uuid,
                startDate: startDate2,
                endDate: endDate2
            },
        };
        let resSeriesTwoSummaryLogs = await getProgressiveSummaryLogs(paramsSeriesTwo);
        setResSeriesTwoSummaryLogs(resSeriesTwoSummaryLogs.data);
        // console.log("resSeriesTwoSummaryLogs===>", resSeriesTwoSummaryLogs);

        let paramsSeriesThree = {
            query: {
                actor: selectedLearnerId,
                site_uuid: userInfo.site_uuid,
                startDate: startDate3,
                endDate: endDate3
            },
        };
        let resSeriesThreeSummaryLogs = await getProgressiveSummaryLogs(paramsSeriesThree);
        setResSeriesThreeSummaryLogs(resSeriesThreeSummaryLogs.data);
        // console.log("resSeriesThreeSummaryLogs===>", resSeriesThreeSummaryLogs)

        if (resSeriesOneSummaryLogs.data.length <= 0 && resSeriesTwoSummaryLogs.data.length <= 0 && resSeriesThreeSummaryLogs.data.length <= 0) {
            setErrorMessage('No Data Found!');
            dispatch(commonSliceActions.setLoader(false));
            return ;
        }

        let seriesOneSkillArr = prepareSkillWiseData(resSeriesOneSummaryLogs);
        // console.log("seriesOneSkillArr==>", seriesOneSkillArr);

        let seriesTwoSkillArr = prepareSkillWiseData(resSeriesTwoSummaryLogs);
        // console.log("seriesTwoSkillArr==>", seriesTwoSkillArr);

        let seriesThreeSkillArr = prepareSkillWiseData(resSeriesThreeSummaryLogs);
        // console.log("seriesThreeSkillArr==>", seriesThreeSkillArr);

        let uniqSkillArr = uniq(concat(map(seriesOneSkillArr, 'name'), map(seriesTwoSkillArr, 'name'), map(seriesThreeSkillArr, 'name')));
        uniqSkillArr.sort();
        setUniqSkillArr(uniqSkillArr);

        setCheckedSkills(uniqSkillArr.map((val) => {
            return {
                'name': val,
                'checked': true
            }
        }))

        let finalSeriesOneSkills = prepareFinalSeriesData(uniqSkillArr, seriesOneSkillArr);
        console.log("finalSeriesOneSkills", finalSeriesOneSkills);
        setFinalSeriesOneSkills(finalSeriesOneSkills);

        let finalSeriesTwoSkills = prepareFinalSeriesData(uniqSkillArr, seriesTwoSkillArr);
        console.log("finalSeriesTwoSkills", finalSeriesTwoSkills);
        setFinalSeriesTwoSkills(finalSeriesTwoSkills);

        let finalSeriesThreeSkills = prepareFinalSeriesData(uniqSkillArr, seriesThreeSkillArr);
        console.log("finalSeriesThreeSkills", finalSeriesThreeSkills);
        setFinalSeriesThreeSkills(finalSeriesThreeSkills);
        dispatch(commonSliceActions.setLoader(false));
    };

    const prepareSkillWiseData = (resSeriesSummaryLogs) => {
        let seriesSkillArr = [];
        // console.log("resSeriesSummaryLogs.data==>", resSeriesSummaryLogs.data.length);
        for (let i = 0; i < resSeriesSummaryLogs.data.length; i++) {
            let skillwiseData = resSeriesSummaryLogs.data[i].outcome.skillwise;
            // console.log("skillwiseData===>", i, "===>", resSeriesSummaryLogs.data[i]);
            for (let j = 0; j < skillwiseData.length; j++) {
                let skillExists = seriesSkillArr.find(function (obj) {
                    return obj.name === skillwiseData[j].name
                });
                // console.log("skillExists====>",skillExists);
                let per = Number(skillwiseData[j].score) / Number(skillwiseData[j].totalAssets);
                // if(skillwiseData[j].name == 'grammar') {
                //     console.log("per====>",per, "=====>score" ,skillwiseData[j]);
                // }
                if (skillExists !== undefined) {
                    let t = (skillExists.per + per) / 2
                    // console.log("t=====>", t);
                    skillExists.per = t;
                    //skillExists.totalAssets += skillwiseData[j].totalAssets;
                } else {
                    let obj = {};
                    obj.name = skillwiseData[j].name;
                    obj.per = per;
                    seriesSkillArr.push(obj);
                }
            }
        }
        seriesSkillArr = sortBy(seriesSkillArr, [
            (o) => {
                return o.name;
            },
        ])
        return seriesSkillArr;
    };

    const prepareFinalSeriesData = (uniqSkillArr, seriesSkillArr) => {
        let finalSeriesSkillsData = [];
        if (uniqSkillArr.length > 0) {
            uniqSkillArr.forEach((skillName) => {
                let skillData = seriesSkillArr.find(function (obj) {
                    return obj.name === skillName
                });
                if (skillData == undefined) {
                    let newSkillData = {};
                    newSkillData.name = skillName;
                    newSkillData.per = 0;
                    finalSeriesSkillsData.push(newSkillData);
                } else {
                    finalSeriesSkillsData.push(skillData);
                }
            });
            finalSeriesSkillsData = sortBy(finalSeriesSkillsData, [
                (o) => {
                    return o.name;
                },
            ])
        }
        // console.log("finalSeriesSkillsData====>",finalSeriesSkillsData);
        return finalSeriesSkillsData;
    };

    const handleOnChange = (itemData) => {
        let durationDays = (Number(itemData.value) / 3) - 1;
        console.log("durationDays====>", durationDays);

        let startDate1 = new Date();
        startDate1 = addDays(startDate1, -itemData.value + 1);
        let endDate1 = addDays(startDate1, durationDays);

        let startDate2 = addDays(endDate1, 1);
        let endDate2 = addDays(startDate2, durationDays);

        let startDate3 = addDays(endDate2, 1);
        let endDate3 = addDays(startDate3, durationDays);

        setStartDate1(getFormatedDate(startDate1, 'YYYY-MM-DD'));
        setEndDate1(getFormatedDate(endDate1, 'YYYY-MM-DD'));

        setStartDate2(getFormatedDate(startDate2, 'YYYY-MM-DD'));
        setEndDate2(getFormatedDate(endDate2, 'YYYY-MM-DD'));

        setStartDate3(getFormatedDate(startDate3, 'YYYY-MM-DD'));
        setEndDate3(getFormatedDate(endDate3, 'YYYY-MM-DD'));

        setSelectedDropdownData([itemData]);
        setSelectedMonthValue(itemData.value);
        //props.filterByDays(itemData)
        resetSkillsData();
        // resetState();
    };

    const selectAllChange = (e) => {
        setAllChecked(e.target.checked);
        let tempArr = [...checkedSkills];
        if (e.target.checked === true) {
            tempArr.map((objArr) => {
                return objArr.checked = true
            });
        } else {
            tempArr.map((objArr) => {
                return objArr.checked = false
            });
        }
        setCheckedSkills(tempArr);
    };

    const changeSkillStatus = (skillObj) => {
        let newArr = [...checkedSkills];
        let foundPos = findIndex(newArr, { 'name': skillObj.name });
        if (foundPos > -1) {
            newArr[foundPos] = {
                ...skillObj,
                'checked': !skillObj.checked
            }
            setCheckedSkills(newArr);
        }
        //Check-Uncheck code here
        let foundUnchecked = newArr.filter((obj) => { return obj.checked === false });
        if (foundUnchecked.length > 0) {
            setAllChecked(false);
        } else {
            setAllChecked(true);
        }
    };

    const resetState = () => {
        setStartDate1(null);
        setEndDate1(null);
        setStartDate2(null);
        setEndDate2(null);
        setStartDate3(null);
        setEndDate3(null);

        setSelectedClassId(null);
        setSelectedLearnerId(null);
        setLearnerData([]);
        setSelectedMonthValue([]);
        setSelectedDropdownData([filterByDays[0]]);
        resetSkillsData();
    };

    const resetSkillsData = () => {
        setUniqSkillArr([]);
        setFinalSeriesOneSkills([]);
        setFinalSeriesTwoSkills([]);
        setFinalSeriesThreeSkills([]);
        setErrorMessage(null);
    };

    return (
        <>
            <TopButton
                title={"Learner Progress Report"}
            >
            </TopButton>
            <Box sx={{ width: '100%' }}>
                <Grid>
                    <Grid container sx={{ flexDirection: 'row', justifyContent: 'space-around', alignItems: 'center' }}>
                        <Grid item xs={10}>
                            <Grid container sx={{ flexDirection: 'row', justifyContent: 'flex-start', alignItems: 'center' }}>
                                <Grid item sx={{ px: 1 }}>
                                    <FormControl sx={{ minWidth: 150 }} size="small">
                                        <ListItemText
                                            primary={
                                                <Typography
                                                    sx={{ px: 1, fontSize: '0.8rem', fontWeight: '500', color: '#DB8829', '@media (min-width: 1636px)': { fontSize: '1.4rem' } }}>
                                                    Select Classes
                                                </Typography>
                                            }
                                        />
                                        <Select
                                            value={selectedClassId}
                                            sx={{
                                                borderRadius: 20, borderColor: '#DB8829', color: '#DB8829', fontWeight: '500', '@media (min-width: 1636px)': {
                                                    fontSize: '1.4rem',
                                                    width: '20ch',
                                                    mt: 0.5
                                                }
                                            }}
                                        >
                                            {allClasses.map((itemData, index) => {
                                                return (
                                                    <MenuItem
                                                        sx={{ color: '#DB8829', fontSize: '0.8rem', fontWeight: '500', '@media (min-width: 1636px)': { fontSize: '1.2rem' } }}
                                                        key={`${index}_Class`}
                                                        value={itemData.id}
                                                        onClick={() => { handleClassChange(itemData) }}>
                                                        {itemData.value}
                                                    </MenuItem>
                                                )
                                            })}
                                        </Select>
                                    </FormControl>
                                </Grid>
                                <Grid item sx={{ px: 1 }}>
                                    <FormControl sx={{ minWidth: 150 }} size="small">
                                        <ListItemText
                                            primary={
                                                <Typography
                                                    sx={{ px: 1, fontSize: '0.8rem', fontWeight: '500', color: '#DB8829', '@media (min-width: 1636px)': { fontSize: '1.4rem' } }}>
                                                    Select Learner
                                                </Typography>
                                            }
                                        />
                                        <Select
                                            value={selectedLearnerId}
                                            sx={{
                                                borderRadius: 20, borderColor: '#DB8829', color: '#DB8829', fontWeight: '500', '@media (min-width: 1636px)': {
                                                    fontSize: '1.4rem',
                                                    width: '20ch',
                                                    mt: 0.5
                                                }
                                            }}
                                        >
                                            {learnerData.map((itemData, index) => {
                                                return (
                                                    <MenuItem
                                                        sx={{ color: '#DB8829', fontSize: '0.8rem', fontWeight: '500', '@media (min-width: 1636px)': { fontSize: '1.2rem' } }}
                                                        key={`${index}_learnerId`}
                                                        value={itemData.uid}
                                                        onClick={() => { handleClassChange1(itemData) }}>
                                                        {joinByKeys(itemData.name,
                                                            ["firstname", "lastname"], " "
                                                        )}
                                                    </MenuItem>
                                                )
                                            })}
                                        </Select>
                                    </FormControl>
                                </Grid>
                                <Grid item sx={{ px: 1 }}>
                                    <FormControl sx={{ minWidth: 150 }} size="small">
                                        <ListItemText
                                            primary={
                                                <Typography
                                                    sx={{ px: 1, fontSize: '0.8rem', fontWeight: '500', color: '#DB8829', '@media (min-width: 1636px)': { fontSize: '1.4rem' } }}>
                                                    Select Month
                                                </Typography>
                                            }
                                        />

                                        <Select
                                            value={selectedMonthValue}
                                            sx={{
                                                borderRadius: 20, borderColor: '#DB8829', color: '#DB8829', fontWeight: '500', '@media (min-width: 1636px)': {
                                                    fontSize: '1.4rem',
                                                    width: '20ch',
                                                    mt: 0.5
                                                }
                                            }}
                                        >
                                            {filterByDays.map((itemData, index) => (
                                                <MenuItem
                                                    sx={{ color: '#DB8829', fontSize: '0.8rem', fontWeight: '500', '@media (min-width: 1636px)': { fontSize: '1.2rem' } }}
                                                    key={`${index}_days`}
                                                    value={itemData.value}
                                                    onClick={() => handleOnChange(itemData)}
                                                >
                                                    {itemData.label}

                                                </MenuItem>
                                            ))}
                                        </Select>

                                    </FormControl>
                                </Grid>
                            </Grid>
                        </Grid>
                        <Grid item xs={2} sx={{ pt: 3 }}>
                            <Grid container sx={{ flexDirection: 'row', justifyContent: 'space-around', alignItems: 'center' }}>
                                <Grid>
                                    <Button
                                        variant="standard"
                                        fullWidth
                                        sx={{
                                            color: "#DB8829",
                                            fontSize: "1rem",
                                            fontWeight: "700",
                                            border: 1,
                                            borderColor: "#DB8829",
                                            borderRadius: 10,
                                           
                                            "@media (min-width: 1636px)": { fontSize: "1.4rem" },
                                        }}
                                        onClick={() => { fetchProgressiveSummaryLog() }}
                                    >
                                        Go
                                    </Button>
                                </Grid>
                                <Grid>
                                    <Button
                                        variant="standard"
                                        fullWidth
                                        sx={{
                                            color: "#DB8829",
                                            fontSize: "1rem",
                                            fontWeight: "700",
                                            border: 1,
                                            borderColor: "#DB8829",
                                            borderRadius: 10,
                                           
                                            "@media (min-width: 1636px)": { fontSize: "1.4rem" },
                                        }}
                                        onClick={() => { resetState() }}
                                    >
                                        Reset
                                    </Button>
                                </Grid>
                            </Grid>
                        </Grid>
                    </Grid>

                    <Grid  
                        sx={{ height: '74vh', overflowY: 'auto', overflowX: 'hidden' }}>
                        <>
                            {finalSeriesOneSkills.length > 0 && finalSeriesTwoSkills.length > 0 && finalSeriesThreeSkills.length > 0 && (
                                <Grid item>
                                    <GroupStackBarChart
                                        uniqSkillArrData={uniqSkillArr}
                                        finalSeriesOneSkillsData={finalSeriesOneSkills}
                                        finalSeriesTwoSkillsData={finalSeriesTwoSkills}
                                        finalSeriesThreeSkillsData={finalSeriesThreeSkills}
                                        seriesOneRange={`${startDate1} - ${endDate1}`}
                                        seriesTwoRange={`${startDate2} - ${endDate2}`}
                                        seriesThreeRange={`${startDate3} - ${endDate3}`}
                                        isHorizontal={true}
                                        chartWidth={'100%'}
                                        chartHeight={480}
                                    />
                                </Grid>
                            )}
                            {finalSeriesOneSkills.length > 0 && finalSeriesTwoSkills.length > 0 && finalSeriesThreeSkills.length > 0 && (
                                <>
                                    <Grid container sx={{ flexDirection: 'row', justifyContent: 'space-around', alignItems: 'center', overflow: 'hidden', height: 'auto', mt: '30px' }}>
                                        <Grid item xs={4} sx={{ borderRight: 1, borderColor: '#CCC' }}>
                                            {resSeriesOneSummaryLogs.length > 0 ?
                                                <PolarProgressChart
                                                    polarChartData={finalSeriesOneSkills}
                                                    colorData={checkedSkills.map((val, index) => {
                                                        if (val && val.checked) {
                                                            return colorsCode[index];
                                                        }
                                                        else {
                                                            return '#ddd';
                                                        }
                                                    })}
                                                    title={`Series-1 (${startDate1} - ${endDate1})`}
                                                    displayLegends={showLegends}
                                                />
                                                :

                                                <Grid>
                                                    <Typography
                                                        color="primary.main"
                                                        sx={{
                                                            color: "#FF0000",
                                                            fontSize: "0.8rem",
                                                            fontWeight: "400",
                                                            marginLeft: 1,
                                                            "@media (min-width: 1636px)": {
                                                                fontSize: "2rem",
                                                            },
                                                        }}
                                                    >
                                                        {`Series-1 (${startDate1} - ${endDate1})`}
                                                    </Typography>
                                                    <Typography
                                                        color="primary.main"
                                                        sx={{
                                                            pl: 5,
                                                            color: "#FF0000",
                                                            fontSize: "0.8rem",
                                                            fontWeight: "400",
                                                            marginLeft: 1,
                                                            "@media (min-width: 1636px)": {
                                                                fontSize: "2rem",
                                                            },
                                                        }}
                                                    >
                                                        {'No data avaliable!'}
                                                    </Typography>
                                                </Grid>

                                            }
                                        </Grid>
                                        <Grid item xs={4} sx={{ borderRight: 1, borderColor: '#CCC' }}>
                                            {resSeriesTwoSummaryLogs.length > 0 ?
                                                <PolarProgressChart
                                                    polarChartData={finalSeriesTwoSkills}
                                                    colorData={checkedSkills.map((val, index) => {
                                                        if (val && val.checked) {
                                                            return colorsCode[index];
                                                        }
                                                        else {
                                                            return '#ddd';
                                                        }
                                                    })}
                                                    title={`Series-2 (${startDate2} - ${endDate2})`}
                                                    displayLegends={showLegends}
                                                />
                                                :
                                                <Grid>
                                                    <Typography
                                                        color="primary.main"
                                                        sx={{
                                                            color: "#FF0000",
                                                            fontSize: "0.8rem",
                                                            fontWeight: "400",
                                                            marginLeft: 1,
                                                            "@media (min-width: 1636px)": {
                                                                fontSize: "2rem",
                                                            },
                                                        }}
                                                    >
                                                        {`Series-2 (${startDate2} - ${endDate2})`}
                                                    </Typography>
                                                    <Typography
                                                        color="primary.main"
                                                        sx={{
                                                            pl: 5,
                                                            color: "#FF0000",
                                                            fontSize: "0.8rem",
                                                            fontWeight: "400",
                                                            marginLeft: 1,
                                                            "@media (min-width: 1636px)": {
                                                                fontSize: "2rem",
                                                            },
                                                        }}
                                                    >
                                                        {'No data avaliable!'}
                                                    </Typography>
                                                </Grid>
                                            }
                                        </Grid>
                                        <Grid item xs={4}>
                                            {resSeriesThreeSummaryLogs.length > 0 ?
                                                <PolarProgressChart
                                                    polarChartData={finalSeriesThreeSkills}
                                                    colorData={checkedSkills.map((val, index) => {
                                                        if (val && val.checked) {
                                                            return colorsCode[index];
                                                        }
                                                        else {
                                                            return '#ddd';
                                                        }
                                                    })}
                                                    title={`Series-3 (${startDate3} - ${endDate3})`}
                                                    displayLegends={showLegends}
                                                />
                                                :
                                                <Grid>
                                                    <Typography
                                                        color="primary.main"
                                                        sx={{
                                                            color: "#FF0000",
                                                            fontSize: "0.8rem",
                                                            fontWeight: "400",
                                                            marginLeft: 1,
                                                            "@media (min-width: 1636px)": {
                                                                fontSize: "2rem",
                                                            },
                                                        }}
                                                    >
                                                        {`Series-3 (${startDate3} - ${endDate3})`}
                                                    </Typography>
                                                    <Typography
                                                        color="primary.main"
                                                        sx={{
                                                            pl: 5,
                                                            color: "#FF0000",
                                                            fontSize: "0.8rem",
                                                            fontWeight: "400",
                                                            marginLeft: 1,
                                                            "@media (min-width: 1636px)": {
                                                                fontSize: "2rem",
                                                            },
                                                        }}
                                                    >
                                                        {'No data avaliable!'}
                                                    </Typography>
                                                </Grid>
                                            }
                                        </Grid>
                                    </Grid>
                                    <Grid container sx={{ flexDirection: 'row', justifyContent: 'flex-start', alignItems: 'center', mt: '10px' }}>
                                        <Grid item
                                            xs={6}
                                             
                                            sx={{
                                                flexDirection: "row",
                                                justifyContent: "flex-start",
                                                overflow: "auto",
                                            }}>
                                            <FormControlLabel
                                                sx={{ pl: 1 }}
                                                style={{
                                                    fontSize: "0.9rem",
                                                    fontWeight: "500",
                                                    color: "#DB8829",
                                                }}
                                                control={
                                                    <Checkbox
                                                        sx={{
                                                            color: blue[800],
                                                            '&.Mui-checked': {
                                                                color: blue[800],
                                                            },
                                                        }}
                                                        checked={allChecked}
                                                        onClick={selectAllChange}
                                                    />
                                                }
                                                label={<Typography sx={{ color: '#DB8829', fontSize: '0.9rem', fontWeight: '600', '@media (min-width: 1636px)': { fontSize: '1.4rem' } }}>
                                                    Select All
                                                </Typography>}
                                            ></FormControlLabel>
                                        </Grid>
                                        <Grid item
                                            xs={6}
                                             
                                            sx={{
                                                flexDirection: "row",
                                                justifyContent: "flex-end",
                                                textAlign: "end",
                                                overflow: "auto",
                                            }}>
                                            <FormControlLabel
                                                sx={{ pl: 1 }}
                                                style={{
                                                    fontSize: "0.9rem",
                                                    fontWeight: "500",
                                                    color: "#DB8829",
                                                }}
                                                control={
                                                    <Checkbox
                                                        sx={{
                                                            color: blue[800],
                                                            '&.Mui-checked': {
                                                                color: blue[800],
                                                            },
                                                        }}
                                                        checked={showLegends}
                                                        onClick={() => {
                                                            setShowLegends((val) => { return !val; })
                                                        }}
                                                    />
                                                }
                                                label={<Typography sx={{ color: '#DB8829', fontSize: '0.9rem', fontWeight: '600', '@media (min-width: 1636px)': { fontSize: '1.4rem' } }}>
                                                    Show Legends
                                                </Typography>}
                                            ></FormControlLabel>
                                        </Grid>
                                    </Grid>
                                    <Grid container sx={{ flexDirection: 'row', justifyContent: 'flex-start', alignItems: 'center', mt: '10px' }}>

                                        {checkedSkills.map((skill, skillIndex) => {
                                            return (
                                                <Grid item xs={3} sx={{}} key={`${skillIndex}_Skills`}>
                                                    <List sx={{ p: 0, m: 0 }}>
                                                        <ListItem
                                                            disablePadding >
                                                            <Checkbox

                                                                checked={skill.checked}
                                                                sx={{
                                                                    padding: 0,
                                                                    color: blue[800],
                                                                    '&.Mui-checked': {
                                                                        color: blue[800],
                                                                    },
                                                                }}
                                                                onChange={() => {
                                                                    changeSkillStatus(skill);
                                                                }} />
                                                            <ListItemText
                                                                primary={
                                                                    <Typography
                                                                        sx={{
                                                                            fontSize: '0.7rem', fontWeight: '500',
                                                                            '@media (min-width: 1636px)': { fontSize: '1rem' }
                                                                        }}
                                                                    >
                                                                        {startCase(skill.name.split('_').join(' '))}
                                                                    </Typography>
                                                                }
                                                            />
                                                        </ListItem>
                                                    </List>
                                                </Grid>
                                            );
                                        })}
                                    </Grid>
                                </>
                            )}                            
                            {!loader && errorMessage && (
                                <Placeholder
                                    primaryText="Learner progress data not found"
                                    secondaryText="No data found!"
                                    image="assign"
                                ></Placeholder>
                            )}

                        </>
                    </Grid>
                </Grid>
            </Box >
        </>
    )
}

const useStyles = makeStyles({
    scrollBar: {
        "&::-webkit-scrollbar": {
            width: "0.6em",
        },
        "&::-webkit-scrollbar-track": {
            backgroundColor: "#ffe600ff",
            "-webkit-box-shadow": "inset 0 0 6px rgba(0,0,0,0.00)",
            borderRadius: 5,
        },
        "&::-webkit-scrollbar-thumb": {
            backgroundColor: "#5f5600ff",
            borderRadius: 5,
        }
    },
});
export default ProgressInTrainerLogin;